export default "/images/vendor/flag-icons/flags/1x1/gf.svg?5fc814b14e4589220c3109a24fa33d47";